import { useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';
import { resetExpiredSession, startSession, useSession } from '../lib/session';
export default function SessionRecovery({
  loading = false,
}: {
  loading?: boolean;
}) {
  const { t } = useTranslation();
  const { isAuthenticated, user } = useAuth0();
  const session = useSession();
  const navigate = useNavigate();
  const location = useLocation();
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  const retry = async (reset: boolean) => {
    setBusy(true);
    setFailed(false);
    try {
      const identity = isAuthenticated ? user!.sub! : 'anonymous';
      const result = reset
        ? await resetExpiredSession(identity)
        : await startSession(identity);
      if (result.claimed || location.pathname === '/auth/callback')
        navigate(result.claimed ? '/history' : '/scan', { replace: true });
    } catch {
      setFailed(true);
    } finally {
      setBusy(false);
    }
  };
  if (loading)
    return (
      <main className="app-main" role="status">
        {t('trial.loading')}
      </main>
    );
  return (
    <main className="app-main">
      <div className="app-main-inner" role="alert">
        <h1>
          {t(
            session.status === 'expired'
              ? 'trial.expiredTitle'
              : 'trial.recoveryTitle'
          )}
        </h1>
        <p>
          {t(
            session.status === 'expired'
              ? 'trial.expiredBody'
              : isAuthenticated
                ? 'trial.claimError'
                : 'trial.sessionError'
          )}
        </p>
        {failed && <p>{t('trial.retryFailed')}</p>}
        <button
          className="button"
          disabled={busy}
          onClick={() => void retry(false)}
        >
          {t('trial.retry')}
        </button>
        {session.status === 'expired' && (
          <button
            className="button button-secondary"
            disabled={busy}
            onClick={() => void retry(true)}
          >
            {t('trial.startNew')}
          </button>
        )}
      </div>
    </main>
  );
}
